import { isUndefined } from 'lodash';

type SortDirection = 'ASC' | 'DESC';
type SortList = Record<string, SortDirection>;

interface ColumnDef {
  sortingGroup: string
  column: string // one or more DB columns, comma-separated
}

/**
 * Build a sort-list mapping each column to ASC/DESC.
 *
 * @param defs           — your array of column definitions
 * @param sortingGroup   — which group the user selected
 * @param sortDirection  — true for ASC, false for DESC
 */
const buildSortList = (
  defs: ColumnDef[],
  sortingGroup: string,
  sortDirection: boolean
): SortList => {
  const def = defs.find((d) => d.sortingGroup === sortingGroup);
  if (!def) return {};

  const direction: SortDirection = sortDirection ? 'ASC' : 'DESC';

  let sortList: any = def.column
    .split(',')
    .map((col) => col.trim())
    .filter((col) => col.length > 0)
    .reduce<SortList>((acc, col) => {
    acc[col] = direction;
    return acc;
  }, {});
  if (!isUndefined(sortList['project.service_client.name'])) {
    sortList = {
      'service_client.name': direction,
    };
  }
  if (!isUndefined(sortList['device_register.mbus_meter_count'])) {
    sortList = {
      mbus_meter_count: direction,
    };
  }
  if (!isUndefined(sortList['device_register.set_register_logs_level'])) {
    sortList = {
      set_register_logs_level: direction,
    };
  }
  return sortList;
};

export default buildSortList;
